<div class="grid-cell-part" [ngClass]="classes()" [attr.title]='tooltip'>

	@if(iconClasses()){
	<i class='grid-cell-icon {{iconClasses()}}'></i>
	}

	<ng-container>
		<ng-content></ng-content>
	</ng-container>
</div>